import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.component.js';
import { propTypes, defaultProps } from './DropZone.types.js';
import styles from './DropZone.module.scss.js';

var DropZone = /** @class */ (function (_super) {
    __extends(DropZone, _super);
    function DropZone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dragging: false,
        };
        /** Counter to keep track of how many elements deep our cursor is  */
        _this.dragCounter = 0;
        _this.handleDragIn = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.dragCounter++;
            if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
                _this.setState({ dragging: true });
            }
        };
        _this.handleDragOut = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.dragCounter--;
            if (_this.dragCounter === 0) {
                _this.setState({ dragging: false });
            }
        };
        _this.handleDrag = function (e) {
            e.preventDefault();
            e.stopPropagation();
        };
        _this.handleDrop = function (e) {
            var onDrop = _this.props.onDrop;
            e.preventDefault();
            e.stopPropagation();
            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                onDrop(e.dataTransfer.files);
                e.dataTransfer.clearData();
                _this.dragCounter = 0;
            }
            _this.setState({ drag: false });
        };
        _this.renderPlacheHolder = function () {
            return (React__default.createElement("div", { className: styles.Placeholder },
                React__default.createElement(Icon, { name: "CloudUploadIcon", alt: "CloudUploadIcon", size: 20, className: styles.Icon }),
                React__default.createElement("p", { className: styles.Placeholder_text }, "Browse or drop image")));
        };
        return _this;
    }
    DropZone.prototype.componentDidMount = function () {
        this.dragCounter = 0;
    };
    DropZone.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        var dragging = this.state.dragging;
        return (React__default.createElement("div", { className: clsx(styles.DropZone, dragging && styles.DropZone___active, className), onDragEnter: this.handleDragIn, onDragLeave: this.handleDragOut, onDragOver: this.handleDrag, onDrop: this.handleDrop, "data-testid": this.props['data-testid'] }, children || this.renderPlacheHolder()));
    };
    DropZone.displayName = 'DropZone';
    DropZone.propTypes = propTypes;
    DropZone.defaultProps = __assign({}, defaultProps);
    return DropZone;
}(React__default.Component));

export { DropZone as default };
